module.exports = __webpack_public_path__ + "img/kanji2.44f89a3b.jpg";